module.exports = __webpack_public_path__ + "img/blog2.6d1e69da.jpg";